import { Box, List, ListItem, Stack, Typography } from "@mui/material";
import { ReactComponent as PrismAi } from "../../shared/assets/prism-ai/prismai-logo.svg"
import NavigateBackButton from "../../shared/components/customNavigateButton/customNavigateButton";
const TermsOfUse = () => {
  const termsList = [
    {
      header: "Eligibility",
      subHeader:
        "Our platform is intended for business users (B2B) only. By using the Services, you represent that: ",
      itemList: [
        "You are authorized to act on behalf of your organization.",
        "You are complying with all applicable laws, including tax laws (e.g., GST).",
      ],
    },
    {
      header: "Account Responsibilities ",
      subHeader: "You must: ",
      itemList: [
        "Provide accurate and up-to-date business and user information.",
        "Keep your login credentials confidential.",
        "Notify us of any unauthorized use of your account. ",
        "You are responsible for all activities under your account.",
      ],
    },
    {
      header: "Use of Services ",
      subHeader:
        "You may use the Services only for lawful procurement and business operations. \n You agree not to:",
      itemList: [
        "Reverse-engineer, modify, or copy platform components. ",
        "Use the Services to transmit any malware, spam, or unauthorized data. ",
        "Attempt to access other users’ data without permission. ",
      ],
    },
    {
      header: "AI and Automation Features",
      subHeader:
        "Our platform uses AI to provide recommendations, insights, and automation for procurement activities. ",
      itemList: [
        "AI outputs are assistance tools, not professional or financial advice.",
        "You are responsible for final procurement decisions based on AI suggestions. ",
      ],
    },
    {
      header: "GST Integration",
      subHeader: "Our GST module provides: ",
      itemList: [
        "Automated invoice extraction ",
        "Reconciliation and compliance support ",
      ],
      note: "While we provide tools for compliance, you remain responsible for accurate tax filings and adherence to local GST laws.",
    },
    {
      header: "Intellectual Property",
      subHeader:
        "All content, software, algorithms, and branding are owned by or licensed to PrismProcure.ai. You may not reproduce or reuse them without prior written permission. ",
      itemList: [],
    },
    {
      header: "Termination ",
      subHeader:
        "We reserve the right to suspend or terminate access to the Services at any time for: ",
      itemList: [
        "Violation of these Terms ",
        "Security threats or misuse",
        "Legal or regulatory requirements",
      ],
      note: "You may discontinue use at any time by deactivating your account. ",
    },
    {
      header: "Limitation of Liability",
      subHeader: "To the maximum extent permitted by law: ",
      itemList: [
        "We are not liable for indirect, incidental, or consequential damages.",
        "We do not guarantee that the Services will be error-free, uninterrupted, or fully accurate at all times. ",
      ],
    },
    {
      header: " Modifications ",
      subHeader:
        'We may update these Terms periodically. Updated versions will be posted on this page with a revised "Last Updated" date. Continued use of the platform implies acceptance of the changes.',
      itemList: [],
    },
    {
      header: "Governing Law",
      subHeader:
        "These Terms are governed by the laws of India. Any disputes shall be subject to the jurisdiction of the courts located in Delhi",
      itemList: [],
    },
    {
      header: "Contact Us",
      subHeader:
        "For questions, concerns, or requests, contact us at:info@prismprocure.ai",
      itemList: [],
    },
  ];

  return (
    <Stack spacing={1} py={4} px={10}>
        <NavigateBackButton
            label={
                "Back to Home"
            }
            navigateLink={"/"}
        />
        <Stack direction={"row"} spacing={1} display={"flex"} justifyContent={"center"}>
            <PrismAi/>
        </Stack>
      <Typography color={"#0F4761"} fontSize={36}>
        Terms of Use
      </Typography>
      <Stack
        direction={"row"}
        display={"flex"}
        justifyContent={"space-between"}
      >
        <Typography fontSize={18} color={"#000000"}>
          Effective Date: 1-Jul-2023
        </Typography>
        <Typography fontSize={18} color={"#000000"}>
          Last Updated: 1-Aug-2025
        </Typography>
      </Stack>
      <Box>
        <Typography fontSize={18} color={"#000000"}>
          Welcome to PrismProcure.ai ("we", "us", or "our"). These Terms of Use
          ("Terms") govern your access to and use of our website, platform, and
          services (“Services”), including AI-powered procurement tools and
          GST-integrated features.
        </Typography>
      </Box>
      <Box>
        <Typography fontSize={18} color={"#000000"}>
          By using PrismProcure.ai, you agree to these Terms. If you do not
          agree, please do not use our platform.
        </Typography>
      </Box>
      {
        termsList.map((terms, index)=>{
            return (
                <Stack key={index}>
        <Typography color={"#0F4761"} fontSize={24} fontWeight={600}>
          {index+1}. {terms.header}
        </Typography>
        <Typography fontSize={18} color={"#000000"}>
          {terms.subHeader}
        </Typography>
        <List sx={{ listStyleType: "disc", pl: 4 }}>
          {
            terms.itemList.map((item, index)=>{
                return (
                    <ListItem sx={{ display: "list-item" }} key={index}>
                        <Typography fontSize={18} color={"#000000"}>
                        {item}
                        </Typography>
                    </ListItem>
                )
            })
          }
        </List>
        {terms.note && <Stack direction={"row"} spacing={1}>
          <Typography fontWeight={600} fontSize={18} color={"#000000"}>
            Note:
          </Typography>
          <Typography fontSize={18} color={"#000000"}>{terms.note}</Typography>
        </Stack>}
      </Stack>
            )
        })
      }
    </Stack>
  );
};

export default TermsOfUse;
